import { render, staticRenderFns } from "./StrategyProjects.vue?vue&type=template&id=66cf5dca&scoped=true"
import script from "./StrategyProjects.vue?vue&type=script&lang=js"
export * from "./StrategyProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cf5dca",
  null
  
)

export default component.exports